import { ContractParametrizationResponseInterface } from '../../../interfaces/response/contract-parametrization/contract-parametrization-response-interface';

export class ContractParametrizationResponseModel implements ContractParametrizationResponseInterface {
  Features: string[] = new Array<string>();
  Phones: string[] = new Array<string>();

  constructor(init?: Partial<ContractParametrizationResponseModel>) {
    Object.assign(this, init);
  }
}
